export default __webpack_public_path__ + "static/media/raspagem-man.7db98423.png";